import { Anchor, Container, Stack, Text, Title } from '@mantine/core';
import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <Container size="sm" py="xl">
      <Stack align="center" gap="md">
        <Title order={1}>Not found</Title>
        <Text c="dimmed">That route doesn&apos;t exist.</Text>
        <Anchor component={Link} to="/">
          Back to dashboard
        </Anchor>
      </Stack>
    </Container>
  );
}
